import { CardSliderList, CardSliderListItem } from '@7f-ui/components/card-slider/card-slider'
import { useMediaState } from '@7f-ui/hooks/use-media-state'
import { NexperienceRecommendationsDocument } from '@data-access/lib/gql/experience/documents'
import { useGraphQL } from '@data-access/lib/graphql-query'
import { ExperienceCard } from '@feat/feat-experience/cards'
import { trackClickRecommendationHdp } from '@feat/feat-tracking/view'

type ADPTeaserProps = {
  accommodationId: number
}

export function ADPTeaser({ accommodationId }: ADPTeaserProps) {
  const isSm = useMediaState('sm')
  const isMobile = useMediaState('mobile')

  const { data: recommendations, isLoading } = useGraphQL(
    NexperienceRecommendationsDocument,
    {
      input: { id: accommodationId, count: 3, type: 'accommodation' },
    },
    { select: data => data.getRecommendations?.nexperiences || [] }
  )

  if (!recommendations || isLoading) return null

  const amountOfItemsToShow = isSm ? 2 : 3

  return (
    <div className="-mx-4 xs:-mx-6 grid md:-mx-12 lg:-mx-16">
      <CardSliderList isSlidable={!isSm} className="px-4 xs:px-6 sm:grid-cols-2 md:px-12 lg:px-16">
        {recommendations?.slice(0, amountOfItemsToShow).map(experience => (
          <CardSliderListItem key={experience.id}>
            <ExperienceCard
              experience={experience}
              isFixedWidth={!isSm}
              onClick={({ href }) => handleTrackClick(href)}
              disableSlider={isMobile}
            />
          </CardSliderListItem>
        ))}
      </CardSliderList>
    </div>
  )
}

function handleTrackClick(href: string) {
  trackClickRecommendationHdp([{ target: href, source: window.location.href }])
}
